import angular from "angular";

import OrganisationOwnerBicyclesModuleRouting from "./organisation-owner-bicycles.module.routing";

export default angular
  .module("vt-organisation-owner-bicycles", [])
  .config(OrganisationOwnerBicyclesModuleRouting);
